(() => {
  if (window.__burdlifeUxFixesLoaded) return;
  window.__burdlifeUxFixesLoaded = true;

  const liveRegion = document.createElement('div');
  liveRegion.className = 'visually-hidden';
  liveRegion.setAttribute('role', 'status');
  liveRegion.setAttribute('aria-live', 'polite');
  liveRegion.setAttribute('aria-atomic', 'true');

  const announce = (message) => {
    if (!message) return;
    liveRegion.textContent = '';
    window.requestAnimationFrame(() => {
      liveRegion.textContent = message;
    });
  };

  const productTitleFor = (button) => {
    const card = button.closest('[data-grid-item], .boost-sd__product-item, .burdlife-piercing-picks__product, .bl-build-stack__card');
    return card?.querySelector('.product-item__title, .boost-sd__product-title, .burdlife-piercing-picks__product-title, .bl-build-stack__product-title')?.textContent?.trim() || 'Product';
  };

  const improveQuickAddLabels = (root = document) => {
    root.querySelectorAll?.('.product-item__image .quick-add__button').forEach((button) => {
      const title = productTitleFor(button);
      const choosesOptions = button.hasAttribute('data-quick-add-btn');
      button.setAttribute('aria-label', choosesOptions ? `Choose options for ${title}` : `Add ${title} to cart`);
      button.title = choosesOptions ? `Choose options for ${title}` : `Add ${title}`;
    });
  };

  const markInvalid = (event) => {
    const field = event.target;
    if (!(field instanceof HTMLElement)) return;
    field.setAttribute('aria-invalid', 'true');
    const name = field.getAttribute('aria-label') || field.closest('label')?.textContent?.trim() || field.getAttribute('placeholder') || 'This field';
    announce(`${name} needs attention.`);
  };

  const clearInvalid = (event) => {
    const field = event.target;
    if (field instanceof HTMLElement && field.matches('input, select, textarea') && field.checkValidity?.()) {
      field.removeAttribute('aria-invalid');
    }
  };

  const init = () => {
    document.body.appendChild(liveRegion);
    improveQuickAddLabels();

    document.querySelectorAll('[data-section-type="collection"]').forEach((section) => {
      const sidebar = section.querySelector('[data-collection-sidebar]');
      const trigger = section.querySelector('[data-collection-nav] [data-aria-toggle]');
      const grid = section.querySelector('[data-products-grid]');
      if (!sidebar || !trigger || !grid) return;
      let lastFilterId = '';
      const isModal = () => sidebar.classList.contains('expanded') &&
        (window.innerWidth < 750 || sidebar.querySelector('[data-collection-sidebar-slide-out]'));
      sidebar.addEventListener('focusin', (event) => { lastFilterId = event.target.id; });
      new MutationObserver((mutations) => {
        if (!isModal()) return;
        const contentChanged = mutations.some((mutation) => mutation.type === 'childList');
        const focusWasLost = document.activeElement === document.body;
        if (contentChanged && focusWasLost) {
          const replacement = lastFilterId && document.getElementById(lastFilterId);
          (replacement || sidebar.querySelector('[data-collection-sidebar-close]'))?.focus({preventScroll: true});
        }
      }).observe(sidebar, {childList: true});
      new MutationObserver(() => {
        grid.setAttribute('aria-busy', String(grid.classList.contains('is-loading')));
      }).observe(grid, {attributes: true, attributeFilter: ['class']});
      document.addEventListener('keydown', (event) => {
        if (!isModal()) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          section.dispatchEvent(new CustomEvent('theme:filter:close'));
          trigger.focus({preventScroll: true});
          return;
        }
        if (event.key !== 'Tab') return;
        const controls = [...sidebar.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, summary, [tabindex="0"]')]
          .filter((control) => control.getClientRects().length && getComputedStyle(control).visibility !== 'hidden');
        const first = controls[0];
        const last = controls.at(-1);
        if (!first) return;
        if (!sidebar.contains(document.activeElement)) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus();
        } else if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      });
    });

    const cartCount = document.querySelector('[data-cart-count]');
    if (cartCount) {
      let previousCount = cartCount.textContent.trim();
      new MutationObserver(() => {
        const nextCount = cartCount.textContent.trim();
        if (nextCount === previousCount) return;
        previousCount = nextCount;
        announce(`Bag updated. ${nextCount || '0'} ${nextCount === '1' ? 'item' : 'items'}.`);
      }).observe(cartCount, { childList: true, characterData: true, subtree: true });
    }

    document.addEventListener('invalid', markInvalid, true);
    document.addEventListener('input', clearInvalid, true);
    document.addEventListener('change', clearInvalid, true);

    document.addEventListener('theme:cart:change', (event) => {
      const title = event.detail?.button ? productTitleFor(event.detail.button) : 'Product';
      announce(`${title} added to your bag.`);
    });

    document.addEventListener('theme:cart:error', (event) => {
      announce(event.detail?.message || 'This item could not be added. Check the options and try again.');
    });

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) improveQuickAddLabels(node);
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
